<template lang="pug">
  .component-tabbed-preauth-list
    .container
      base-list(
        :component="component",
        :dataLoader="dataLoader",
        :showPerPageSelect="false",
        :component-type="reservation !== null ? 'reservation' : 'listing'"
      )
</template>

<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import BaseList from "./BaseList"

export default {
  name: "PreauthList",
  components: {BaseList},
  data() {
    return {
      component: require('src/components/backoffice/Preauth'),
    }
  },
  methods: {
    dataLoader(callback, page = 1, resultsPerPage = 25) {
      const body = this.reservation ? {reservation_id: this.reservation.id} : null
      return KeplerBackofficeSdk.reservations.list(page, resultsPerPage,).preauths(body, (data) => {
        callback(data)
      })
    },
  },
  props: {
    reservation: {
      type: Object,
      default: null,
    }
  }
}
</script>



// WEBPACK FOOTER //
// PreauthList.vue?37567389